import './section4.css'

const stats = [
    { number: '10+', label: 'Anos de Experiência' },
    { number: '15+', label: 'Clientes Satisfeitos' },
    { number: '200+', label: 'Projetos Concluídos' },
    { number: '50K+', label: 'Horas de Desenvolvimento' },
]

export default function Section4() {
    return (
        <div id="section4" className="container-fluid">
            <div className="container d-flex align-items-center justify-content-center">
                <div className="row w-100 py-5 my-3">
                    <div className="col-12 text-center mb-4">
                        <p className="titulo">Nossos números</p>
                        <p className="sub-titulo mt-2">Resultados que falam por si</p>
                    </div>

                    {stats.map((stat, i) => (
                        <div key={i} data-aos="fade-up" className="col-md-3 col-6 text-center mt-4">
                            <div className="stat-number">{stat.number}</div>
                            <div className="stat-label">{stat.label}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
